// Author Image Mapping
// Update local paths or URLs here to change author images across the blog
export const AUTHOR_IMAGES: Record<string, string> = {
    'Michelle Simmons': '/images/Team Members Resized/AuthorMichelle.jpeg',
    'Mechelle E. Salley': '/images/Team Members Resized/AuthorMechelle.jpeg',
    'Mechelle E Salley': '/images/Team Members Resized/AuthorMechelle.jpeg',
    'Elicia Tillis': '/images/Team Members Resized/AuthorElicia.jpeg',
};
